import { Button, Stack, Text } from '@mantine/core';
import { NavLink } from 'react-router-dom';
import { useAuth } from '@workos-inc/authkit-react';
import { IconBuildings, IconChevronLeft, IconLayoutBoard } from '@tabler/icons-react';
import { DEFAULT_STAFF_PATH, STAFF_ORGANISATIONS_PATH } from '../../staff/staffNav';
import { canEditEntitlements, canReadCatalogue } from '../../staff/staffAccess';

const STYLES = {
  '--button-color': 'var(--text-muted)',
  '--button-hover': 'var(--bg-subtle)',
  '--button-hover-color': 'var(--text-default)',
};

export function StaffSidebar() {
  // Each section shows only to staff whose permission the server would accept there — a
  // grants-only operator gets no Products link pointing at a catalogue 403, and vice versa.
  const { permissions } = useAuth();
  return (
    <Stack component="aside" p="18px 12px" bg="var(--bg-surface)" gap={4} w={232}
      style={{ flexShrink: 0, borderRight: '1px solid var(--border-default)' }}>
      <Button component={NavLink} to="/" mb={8} variant="subtle" w="100%" px={12} fz="xs" h="2rem"
        display="flex" justify="flex-start" leftSection={<IconChevronLeft size={16} />} style={STYLES}>
        Back to Hub
      </Button>
      {canReadCatalogue(permissions) && (
        <>
          <Text fz={10} c="var(--text-subtle)" tt="uppercase" p="12px 12px 6px" fw={700} lts="0.6px">Catalogue</Text>
          <Button component={NavLink} to={DEFAULT_STAFF_PATH} className="profile-nav"
            variant="subtle" w="100%" px={12} fz="sm" h="2.25rem" display="flex" justify="flex-start"
            leftSection={<IconLayoutBoard size={16} style={{ flexShrink: 0 }} />} style={STYLES}>
            Products
          </Button>
        </>
      )}
      {canEditEntitlements(permissions) && (
        <>
          <Text fz={10} c="var(--text-subtle)" tt="uppercase" p="12px 12px 6px" fw={700} lts="0.6px">Organisations</Text>
          <Button component={NavLink} to={STAFF_ORGANISATIONS_PATH} className="profile-nav"
            variant="subtle" w="100%" px={12} fz="sm" h="2.25rem" display="flex" justify="flex-start"
            leftSection={<IconBuildings size={16} style={{ flexShrink: 0 }} />} style={STYLES}>
            Customers
          </Button>
        </>
      )}
    </Stack>
  );
}
